// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__3qrkY","namePhoneContainer":"style_namePhoneContainer__3Ngyg"};